import * as React from 'react';

interface FormProps {
  formId?: string;
  /**
   * Automatically prevents the default browser behavior so you don't have to
   */
  onSubmit: () => any;

  children?: React.ReactNode;
}
export const Form: React.FC<FormProps> = ({ formId, onSubmit = () => {}, children }: FormProps) => {
  return (
    <form
      id={formId}
      name={formId}
      onKeyDown={
        (e) => {
          /**
           * Note: Pressing enter in some input in a browser forms
           *  triggers onClick on the first child button.
           * Demo : https://jsfiddle.net/basarat/bdqk4d2b/ focus on input and press enter.
           *
           * So, prevent `enter` from triggering `onClick` on any buttons
           *  and instead trigger onSubmit
           */
          if (e.key === 'Enter') {
            e.preventDefault();
            onSubmit();
          }
        }
      }

      onSubmit={
        (e) => {
          /**
           * Prevent submit from reloading the page
           */
          e.preventDefault();
          e.stopPropagation();
          onSubmit();
        }
      }
    >
      {children}
    </form>);
}


